import { Component, OnInit, Input, ChangeDetectionStrategy, NgZone, ElementRef, Inject } from '@angular/core';
import { ImageItem } from '../image-item/image-item.component';
import { Observable } from 'rxjs';
import { DEVICE_INFO, DeviceInfo } from 'angular-engine/modules/ng-express-engine/tokens';

const target = typeof window !== 'undefined' ? window : undefined;

@Component({
  selector: 'row-header',
  templateUrl: './row-header.template.html',
  styleUrls: ['./row-header.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RowHeader {
  @Input() row$: any;
  @Input() showCount: boolean;
  @Input() showSeasonButton: boolean;
  @Input() fullCopy: boolean; //false = 'summary', true = 'description'
  @Input() showSubhead: boolean;
  @Input() actionMessage: string;
  @Input() hideTitle: boolean;
  @Input() actionRoute:string;
  @Input() invert:boolean;
  private elementRef: ElementRef;
  private ngZone: NgZone;
  private showPlayAll: boolean;
  private scrollTarget:any = target;
  private scrollSubscription:any;

  constructor(
    el: ElementRef,
    ngZone: NgZone,
    @Inject(DEVICE_INFO) private deviceInfo: DeviceInfo
    ) { 
      this.elementRef = el;
      this.ngZone = ngZone;
    }

  ngOnChanges()
  {
    const meta = this.row$['meta'] || {};
    const data = this.row$['data'] || [];
    const totalCount = meta.total_count || data.length || 0;
    const playlistRoute = this.actionRoute || this.row$['playlist_internal_route'];

    if (this.actionMessage && playlistRoute && totalCount > 0) {
      this.row$["total_count"] = totalCount;
      this.showPlayAll = totalCount > 1;
    }
    else {
      this.showPlayAll = false;
    }
  }

  ngAfterContentInit(){

  }

  private setLoadedStyle(element: HTMLElement) {
    const styles = element.className
        .split(' ')
        .filter(s => !!s)
        .filter(s => s !== 'stuck')
        .filter(s => s !== 'unstuck');
        
    styles.push('stuck');
    element.className = styles.join(' ');
    return element;
  }

  private setUnloadedStyle(element: HTMLElement) {
    const styles = element.className
        .split(' ')
        .filter(s => !!s)
        .filter(s => s !== 'unstuck')
        .filter(s => s !== 'stuck');
        
        
    styles.push('unstuck');
    element.className = styles.join(' ');
    return element;
  }

  private scrollWatch(item: HTMLElement) {

    return (scrollObservable: Observable<Event>) => {
        return scrollObservable
            .map(val => this.isVisible(item))
            
    };
  }

  private isVisible(element: HTMLElement, threshold = 50, _window = window) {
    const rect = element.getBoundingClientRect();
    // Is the top of the element in the viewport
    const topInsideStuckSpace = rect.top <= threshold;
    // Is the bottom of the element in the viewport
    if(topInsideStuckSpace)
      {
        this.setLoadedStyle(element);
      }

      else
        {
          this.setUnloadedStyle(element);
        }

  }

  ngOnDestroy() {
        [this.scrollSubscription]
            .filter(subscription => subscription && !subscription.isUnsubscribed)
            .forEach(subscription => subscription.unsubscribe());
    }

  get copy() {
    let meta = this.row$.meta || this.row$;

    if(this.deviceInfo.isPhone){
      return meta.summary;
    }

    return this.fullCopy ? meta.description : meta.summary;
  }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/row-header/row-header.component.ts